import styled from 'styled-components';
export const LayoutWrapper = styled.div `
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
`;
export const MainContent = styled.main `
  flex: 1;
  padding-top: 70px; /* Account for fixed header */
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 70px);
`;
